<!-- <IFA-header></IFA-header> -->

<main id="primary" class="site-main customMain">
  <section class="relative">
    <div class="container px-4 pt-5 mt-120">
      <div class="content-panelMobile">
        <div class="row d-flex">
          <div class="col-12">
            <div class="sb-tag sb-offerings mb-12">MUTUAL FUNDS</div>
            <h2 class="wealth-section-title mb-6">
              Systematic Investment Plan - SIP
            </h2>
            <p class="wealth-section-description">
              Know the benefits and start your wealth journey.
            </p>
          </div>
        </div>
        <!-- mutual fund Accordian-->

        <div
          class="lg:w-full lg:max-w-full post-content pb-4 pt-8 lg:pt-6 sm:pt-4">
          <div class="wp-block-columns sec-ques-ans">
            <div class="wp-block-column" style="flex-basis: 30%">
              <div class="sidebar-block sticky pt-16">
                <div
                  id="lpwtoc_widget-3"
                  class="widget widget-sidebar widget_lpwtoc_widget">
                  <!--noindex-->
                  <div
                    class="lwptoc lwptoc-autoWidth lwptoc-inherit"
                    data-smooth-scroll="1"
                    data-smooth-scroll-offset="60"
                    data-lwptoc-initialized="1">
                    <div class="lwptoc_i">
                      <div class="lwptoc_header">
                        <b class="lwptoc_title bold UpperCase">
                          SIP & its benefits
                        </b>
                      </div>
                      <div
                        class="lwptoc_items1 lwptoc_items-visible"
                        style="font-size: 12pt">
                        <ol class="lwptoc_itemWrap">
                          <li class="lwptoc_item active">
                            <a href="#Tab1" data-toggle="tab" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Systematic Investment Plan - SIP
                              </span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab2" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Rupee Cost Averaging
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab3" rel="nofollow">
                              <span class="lwptoc_item_label">
                                The Power Of Compounding
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab4" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Starting Early Pays Well
                              </span>
                            </a>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                  <!--/noindex-->
                </div>
              </div>
            </div>

            <div class="wp-block-column mt-120" style="flex-basis: 70%">
              <div
                class="answer-contents calculator_accordian desktop-disabled-acc"
                id="ques_ans_accordian">
                <div class="what-is-hra ans-card" id="Tab1">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab1_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      SIP
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab1_ans">
                    <div class="main-panel">
                      <div class="item-text">
                        <p class="img-block">
                          <img
                            src="assets/images/img/sys.jpg"
                            alt="Sebi Complaints Readdress System - Register Complaints Online" />
                        </p>
                        <div class="img-txt-block">
                          <p>
                            Systematic Investment Plan (SIP) is an investment
                            plan (methodology) offered by Mutual Funds wherein
                            one could invest a fixed amount in a mutual fund
                            scheme periodically, at fixed intervals – say once a
                            month, instead of making a lump-sum investment.
                          </p>
                          <p>
                            The SIP instalment amount could be as little as ₹500
                            per month. SIP is similar to a recurring deposit
                            where you deposit a small /fixed amount every month.
                          </p>
                        </div>
                        <p>
                          SIP is a very convenient method of investing in mutual
                          funds through standing instructions to debit your bank
                          account every month, without the hassle of having to
                          write out a cheque each time.
                        </p>
                        <p>
                          SIP has been gaining popularity among Indian MF
                          investors, as it helps in Rupee Cost Averaging and
                          also in investing in a disciplined manner without
                          worrying about market volatility and timing the
                          market. Systematic Investment Plans offered by mutual
                          funds are easily the best way to enter the world of
                          investments over the long term.
                        </p>
                        <p>
                          Common sense suggests that “Buying low and selling
                          high” is perhaps the best way to get good returns on
                          your investments. But this is easier said than done,
                          even for the most experienced investors. There are
                          many factors at play when it comes to any market -
                          debt or equity, and all of them are inextricably
                          linked.
                        </p>
                        <p>
                          SIP is a simpler approach to long term investing is
                          disciplining and committing to a fixed sum for a fixed
                          period and sticking to this schedule regardless of the
                          conditions of the market.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab2">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab2_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Rupee cost averaging
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab2_ans">
                    <div class="main-panel">
                      <div class="item-text">
                        <p>
                          Rupee cost averaging, as this practice is called, in a
                          way ensures that you automatically buy more units when
                          the NAV is low and fewer when the NAV is high…e.g., an
                          SIP of ₹1000 gets you 50 units when the NAV is Rs. 20,
                          but gets you 100 units when the NAV is Rs.10. The
                          average cost for buying those 150 units would be Rs.
                          2000/150 units i.e. ₹ 13.33. However, please remember
                          that the Rupee cost averaging does not assure profit,
                          nor does it protect one against investment losses in
                          declining markets. It merely ensures disciplined &
                          regular investment in stock markets, which helps
                          overcome the natural impulse to stop investing in a
                          falling or a depressed market or investing a lot, when
                          markets are buoyant and euphoric.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab3">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab3_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      The Power of Compounding
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab3_ans">
                    <div class="main-panel">
                      <div class="item-text">
                        <p>
                          There is a great advantage with long-term investments,
                          namely,
                          <strong>compounding</strong>
                          which is considered one of the greatest mathematical
                          discovery.
                        </p>
                        <p>
                          To put it in simple words, compounding is when the
                          interest (or income) you earn is reinvested in the
                          original corpus and accumulated corpus continues to
                          earn (&amp; grow). Every time this happens, your
                          investment keeps growing, paving the way for a
                          systematic accumulation of money, multiplying over
                          time.
                        </p>
                        <p>
                          To illustrate, a small amount of ₹1000 invested every
                          month at an interest rate of 8% for 25 years would
                          give you ₹ 9.57 Lakh! That means your investment of
                          just ₹ 3 Lakh would have grown three times over!
                        </p>
                        <p>
                          Here is a graph that represents the same for a time
                          period of 15 years.
                        </p>
                        <p class="center">
                          <img
                            src="assets/images/img/bar-graph.gif"
                            alt="graph" />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab4">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab4_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Starting Early Pays Well
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab4_ans">
                    <div class="main-panel">
                      <div class="item-text">
                        <p>
                          To get the best out of your investments, it is very
                          important to invest for the long-term, which means
                          that you should start investing early, in order to
                          maximize the end returns.
                        </p>
                        <p>
                          Let’s understand this better through an illustration –
                        </p>
                        <p>
                          Let's assume that two friends, both aged 25, decide to
                          invest ₹ 2000 every month for a period of 5 years and
                          earn 8% p.a. on a monthly compounding basis. The only
                          difference is that while one starts investing promptly
                          at the age of 25 itself, the other starts investing 10
                          years later at the age of 35 years. Both decide to
                          hold on to their investments till they turn 60. So
                          while both of them would accumulate principal
                          investment of ₹1.2 Lakh over a period of 5 years, the
                          investment of the person who started early at the age
                          of 25 appreciates to over ₹ 14 Lakh, the investment of
                          the second person who started later grows to only
                          about ₹ 6 Lakh.
                        </p>
                        <p>
                          Thus, you can clearly see the difference between the
                          two and the clear advantage of investing early. So go
                          ahead. Start investing through SIP today itself.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End-->
      </div>
    </div>
  </section>

  <!-- lets talk of model -->
  <section class="grid-layout-common">
    <div class="container">
      <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
        <div class="product-card-grid hover-animation" data-grid-size="8">
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Mutual-Fund"
            target="_self">
            <span>
              Mutual Funds -
              <br />
              <span class="no-wrap-text">Introduction & More</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Types_Of_MF"
            target="_self">
            <span>
              Various types
              <br />
              <span class="no-wrap-text">of Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card active"
            href="mf/SIP"
            target="_self">
            <span>
              Systematic
              <br />
              <span class="no-wrap-text">Investment Plan?</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Advantages_Of_MutualFundsComponent"
            target="_self">
            <span>
              Advantages of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/categorization-of-mutual-funds"
            target="_self">
            <span>
              Categorisation of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/risks-in-mutual-funds"
            target="_self">
            <span>
              Risk Factors in
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#Myth"
            target="_self">
            <span>
              Myths & Facts
              <br />
              <span class="no-wrap-text">about Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#FAQ"
            target="_self">
            <span>
              What is NAV?
              <br />
              <span class="no-wrap-text">& Other FAQs</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd"
            class="card link-plain featured customCard"
            (click)="modalPopOpen()"
            target="_self">
            <p
              style="
                font-size: 19px;
                color: #000;
                font-weight: bold;
                margin-bottom: 0px;
              ">
              Schedule a Call back
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>
  <div
    aria-hidden="true"
    aria-labelledby="LetsTalk_popup"
    class="modal fade"
    data-keyboard="false"
    id="LetsTalk_popup"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered border-0">
      <div class="modal-content border-0 p-0">
        <div class="modal-header border-0 p-0 ltmodalheader">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body border-0 p-10 pt-0 mobilep-2">
          <form>
            <div
              class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
              <div class="align-self-center">
                <h2
                  class="wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth">
                  Let's Talk
                </h2>

                <p
                  class="wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10">
                  Let's connect on a quick call to understand better.
                </p>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 mt-10 mobilemt-0">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Full Name"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                    <div class="call-plan-form-group call-plan-form-group-name">

                      <input class="form-control" id="customer_name" placeholder="last name"
                        maxlength="30" name="customer-name" required="" type="text">
                      <label for="customer-name"></label>
                      <span class="d-none customer-name-error" style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div> -->
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Mobile"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      placeholder="Email"
                      maxlength="30"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <!-- <select class="form-control">
                      <option>State</option>
                    </select> -->
                    <input
                      class="form-control"
                      id="Statein"
                      placeholder="State"
                      maxlength="30"
                      name="Statein"
                      required=""
                      type="text" />
                    <label for="Statein"></label>
                    <span class="d-none Statein-error" style="color: red">
                      Please enter state
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="City"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Message"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="call-plan-form-group">
                    <label class="form-label">Preferred time to talk:</label>
                  </div>
                  <div
                    class="btn-group btn-group-toggle select-call-time select-call-time-js"
                    data-toggle="buttons">
                    <label class="btn btn-outline-sb-green option-1 active">
                      <input
                        data-max="12"
                        data-min="8"
                        id="option1"
                        name="schedule_time"
                        type="radio"
                        value="morning" />

                      10 - 12
                    </label>
                    <label class="btn btn-outline-sb-green option-2">
                      <input
                        data-max="16"
                        data-min="12"
                        id="option2"
                        name="schedule_time"
                        type="radio"
                        value="afternoon" />

                      12 - 2
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      2 - 4
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      4 - 6
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      6 - 8
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-20">
                  <div
                    class="call-plan-form-group text-center mt-30 mobilemt-0 mobilemb-0">
                    <div
                      class="mt-3 sb-primary-cta-button large-btn schedule-a-call trigger-event schedule-a-call-js"
                      data-action="schedule a call-Plan"
                      data-category="offering-Plan"
                      data-label="planning section">
                      Call Me
                    </div>
                    <a
                      href="mf/MobileMutualFund"
                      style="font-size: 10px"
                      target="_self"
                      class="anchorColor desktopHide">
                      Click here to know more about Mutual Funds first
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
<IFA-footer></IFA-footer>
